import Vue from 'vue'
import Vuex from 'vuex'

import UserModel from '@/models/user.model.js';



Vue.use(Vuex)


const store = new Vuex.Store({
    state: {
     user: {},
     userLog: {}
    },
    getters: {
      user: state => state.user,
      userLog: state => state.userLog
    },
    mutations: {
      setUser (state, data) {
        const userModel = new UserModel(data)
        const user = userModel.getData()
        state.user = {...user}
      },
      setUserLog (state, data) {
        state.userLog = data
      },
      clearUser(state) {
        state.user = {},
        state.userLog = {}
      },
    }
})

export default store;